import {KeyStorage} from './Storage';

const STORAGE_KEY = 'esis'; // eazyshow in session
type StorageDataType = {
    showedMoreTooltip: boolean;
}
export const InSessionDataStorage = new KeyStorage<StorageDataType>(STORAGE_KEY, {base64: true});
